angular.module('bmsApp.dashboard').controller('PushNotificationFormModalCtrl', [
	'$scope',
	'$log',
	'$timeout',
	'$q',
	'$modalInstance',
	'$ngBootbox',
	'PushNotificationSvc',
	'EmployeeOptionsSvc',
	function ($scope, $log, $timeout, $q, $modalInstance, $ngBootbox, PushNotificationSvc, EmployeeOptionsSvc) {

		$scope.cancel = function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		};

		$scope.init = function () {
			$scope.processing = false;
			var employeeOptionsPromise = EmployeeOptionsSvc.employee({filter: {status: true, withFcmToken: true}});
			var promises = [employeeOptionsPromise];
			$q.all(promises)
				.then(function (responses) {
					$scope.employeeOptions = responses[0].data.options;
					$scope.enableSubmit = true;
				});
		};

		$scope.submit = function () {
			$scope.processing = true;

			var modalResult = {
				success: false
			};

			var savePromise = PushNotificationSvc.send($scope.pushNotification);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					$modalInstance.close(modalResult);
				}, function (errors) {
					$scope.errors = errors
					modalResult.errors = errors;
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.formvalidatorconfig = {
			submitHandler: function (form) {
				$scope.submit();
			},
			errorPlacement: function (error, element) {
				error.appendTo('#note-errors');
			},
			errorContainer: '#note-errors'
		};

	}]);
